import { DoCheck, KeyValueDiffers, Component, Input, Output, EventEmitter, OnInit, ChangeDetectorRef, AfterViewChecked, ViewChild, AfterViewInit, forwardRef, KeyValueDiffer, OnChanges, SimpleChanges } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

import { DocumentModel } from '../../Models/DocumentModel';

import { DocumentConfiguration } from '../../Models/DocumentConfiguration';
import { FileUploadModule, FileUpload } from '../../../primeng/components/fileupload/fileupload';
import { CustomValidationResult } from '../../../modules/grid/Models/GridColumn';
import { environment } from 'environments/environment';

import { DomSanitizer } from '@angular/platform-browser';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, AbstractControl } from '@angular/forms';
import { UploaderService } from '../../Providers/uploader.service';
import { TempEServicesDocumentModel } from '../../Models/TempEServicesDocumentModel';


@Component({
  selector: 'app-uploader',
  templateUrl: './uploader.component.html',
  styleUrls: ['./uploader.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => UploaderComponent),
    }
  ],
  host: { '(blur)': 'onTouched($event)' },
})
export class UploaderComponent implements OnInit, AfterViewInit, AfterViewChecked, ControlValueAccessor, OnChanges/*, DoCheck*/ {

  @Input() documents: Array<DocumentModel>;
  @Output() documentsChange: EventEmitter<Array<DocumentModel>> = new EventEmitter<Array<DocumentModel>>();

  @Input() allRequestAttachments: Array<DocumentModel>
  @Output() allRequestAttachmentsChange: EventEmitter<Array<DocumentModel>> = new EventEmitter<Array<DocumentModel>>();

  @Input() documentConfiguration: DocumentConfiguration;

  @Input('MinNumberOfFiles') MinNumberOfFiles: number = 0;
  @Input('MaxNumberOfFiles') MaxNumberOfFiles: number = 1;

  @Input('chooseLabel') chooseLabel: string;
  @Input('uploadLabel') uploadLabel: string;
  @Input('cancelLabel') cancelLabel: string;
  @Input('Required') required: boolean;
  @Input('viewMode') viewMode: boolean = false;
  @Input('isSubmitted') isSubmitted: boolean;
  @Input() label: string;
  @Input() hint: string;
  @Input() resources: any;
  @Input() isCRM: boolean = false;
  @Input() isHideDownload: boolean = false;
  @Input() crmServiceId: string = "";
  @Input() crmRequestId: string = "";
  @Input() crmConfigId: string = "";
  @Input() otherMessages: string[];

  @Input() disabled: boolean = false;
  @Output() IsValid: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() IsFileUploaded: EventEmitter<boolean>;

  @Input('isOfflineUpload') isOfflineUpload: boolean;
  @Input() files: Array<any>;
  @Output() filesChange: EventEmitter<Array<any>> = new EventEmitter<Array<any>>();

  isTouched: boolean = false;
  @ViewChild(FileUpload) uploader: FileUpload;
  differ: KeyValueDiffer<string, any>;
  myFile = [];
  file: File;
  base64String: string;

  isMultiple: boolean = false;

  isReachMaxFile: boolean = false;
  isAlreadyUploaded: boolean = false;

  isReachMaxFileSize: boolean;
  errors: CustomValidationResult;
  addDocumentUrl: string;
  getRealDocumentUrl: string;

  warningMsgs: string[]

  realDownloadLink: string;
  tempDownloadLink: string
  showLoader: boolean = false;
  constructor(private http: HttpClient,
    private cdRef: ChangeDetectorRef,
    private sanitizer: DomSanitizer,
    private differs: KeyValueDiffers) {
    this.warningMsgs = new Array<string>();
    this.differ = this.differs.find({}).create();
    this.IsFileUploaded = new EventEmitter<boolean>();
  }

  //=============================================================================================
  // Uploader Component Lifecycle Hooks
  isUploaderReady = false;
  ngOnInit() {
    if (this.isCRM) {
      this.realDownloadLink = environment.crmUploader_download;
      this.tempDownloadLink = environment.crmUploader_download;
      this.addDocumentUrl = environment.crmUploader_add;
      this.getRealDocumentUrl = environment.crmUploader_getRealFile;
    } else {
      this.realDownloadLink = environment.uploader_download;
      this.tempDownloadLink = environment.uploader_downloadTemp;
      this.addDocumentUrl = environment.uploader_add;
      this.getRealDocumentUrl = environment.uploader_getRealFile;
    }
    if (this.MaxNumberOfFiles > 1) {
      this.isMultiple = true;
    }

    if (!this.documents) {
      this.documents = new Array<DocumentModel>();
    }
    else {
      for (var i = 0; i < this.documents.length; i++) {
        this.documents[i].SizeToShow = this.calculateFileToShow(this.documents[i].Size);
      }
    }
    
    if (this.warningMsgs.length == 0) {
      let ExtensionsMsg: string = this.resources.g_uploader_allowedFileExtensions +
        this.resources.g_lbl_space +
        this.documentConfiguration.AllowedExtension;

      let MaxSizeMsg: string = this.resources.g_uploader_MaxFileSize +
        this.resources.g_lbl_space +
        this.documentConfiguration.AllowedSize / 1000000 +
        this.resources.g_lbl_space +
        this.resources.g_fileSizeUnitInMB

      this.warningMsgs
        .push(ExtensionsMsg, MaxSizeMsg);
      if (this.otherMessages && this.otherMessages.length > 0) {
        this.warningMsgs=this.warningMsgs.concat(this.otherMessages);
      }
    }
    if (!this.allRequestAttachments)
      this.allRequestAttachments = new Array<DocumentModel>();
    this.isUploaderReady = true;
    this.CheckIsRequiredValid();
    this.IsFileUploaded.emit(true);
  }

  ngAfterViewInit(): void {
    this.OverrideValidate();
  }

  ngAfterViewChecked() {
    this.cdRef.detectChanges();
  }

  //=============================================================================================
  // Override upload event
  myUploader(event) {
    if (!this.isReachMaxFile) {
      if (event.files.length == 0) {
        return;
      }

      var fileToUpload = event.files[event.files.length - 1];
      if (this.IsFileAlreadyUploaded(fileToUpload)) {
        return;
      }

      if (this.isOfflineUpload) {
        this.uploadOfflineDocument(fileToUpload);
        return;
      }

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        })
      };
      
      this.convertFileToBase64(fileToUpload).subscribe((result) => {
        this.IsFileUploaded.emit(false);
        let document: TempEServicesDocumentModel = {
          content: result,
          name: fileToUpload.name.split('.').slice(0, -1).join('.'),
          extension: fileToUpload.name.split('.')[fileToUpload.name.split('.').length - 1],
          mimeType: fileToUpload.type,
          size: fileToUpload.size,
          DocumentConfiguration: this.documentConfiguration.Key,
          crmServiceId: this.crmServiceId,
          crmRequestId: this.crmRequestId,
          crmConfigId: this.crmConfigId
        };
        this.showLoader = true;
        this.IsValid.emit(false)
        this.http.post<string>(this.addDocumentUrl, document, httpOptions)
            .subscribe(data => {
              this.IsValid.emit(true);
              this.IsFileUploaded.emit(true);
              let sizeToShow = this.calculateFileToShow(document.size);
              let uploadedDocument: DocumentModel = {
                TempId: data,
                Name: document.name,
                extension: document.extension,
                mimeType: document.mimeType,
                Size: document.size,
                SizeToShow: sizeToShow,
              };
              this.showLoader = false;
              if (this.isMultiple) {
                this.documents.push(uploadedDocument);
              }
              else {
                if (this.documents.length == 0) {
                  this.documents.push(uploadedDocument);
                }
                else {
                  for (var i = 0; i < this.documents.length; i++) {
                    this.documents[i].IsDeleted = true;
                    let oldDoc = this.allRequestAttachments.filter(x => x.RealId == this.documents[i].RealId && x.TempId == this.documents[i].TempId);
                    if (oldDoc.length > 0) {
                      let index = this.allRequestAttachments.indexOf(oldDoc[0]);
                      if (index > -1)
                        this.allRequestAttachments[index].IsDeleted = true;
                    }
                  }
                  this.documents.push(uploadedDocument);
                  //if (this.documents[0].realId != null && this.documents[0].realId != "") {
                  //  this.documents[0].isDeleted = true;
                  //  this.documents.push(uploadedDocument);
                  //  let oldRealDoc = this.allRequestAttachments.filter(x => x.realId == this.documents[0].realId);
                  //  if (oldRealDoc.length > 0) {
                  //    let index = this.allRequestAttachments.indexOf(oldRealDoc[0]);
                  //    if (index > -1)
                  //      this.allRequestAttachments[index].isDeleted = true;
                  //  }
                  //}
                  //else {
                  //  let oldTempDoc = this.allRequestAttachments.filter(x => x.tempId == this.documents[0].tempId);
                  //  if (oldTempDoc.length > 0) {
                  //    let index = this.allRequestAttachments.indexOf(oldTempDoc[0]);
                  //    if (index > -1)
                  //      this.allRequestAttachments.splice(index, 1);
                  //  }
                  //  this.documents[0] = uploadedDocument;
                  //}
                }
              }
              this.allRequestAttachments.push(uploadedDocument);
              this.documentsChange.emit(this.documents);
              if (this.onModelChange)
                this.onModelChange(this.documents);

              this.allRequestAttachmentsChange.emit(this.allRequestAttachments);
              this.IsValid.emit(true);
              this.CheckIsRequiredValid();
         });
      }, (error) => {
        this.showLoader = false;
        this.IsFileUploaded.emit(false);
        if (!this.errors) {
          this.errors = {};
        }
        this.errors.anError = {
          errorMessage: 
            this.resources.g_popup_genericErrorMessage
        }
        this.IsValid.emit(true);
      });
    }
    else {
      if (this.MaxNumberOfFiles <= event.files.length - 1) {
        event.files.pop();
      }
    }
  }
  //=============================================================================================
  onSelect(event) {
    this.isTouched = true
    if (this.isMultiple) {
      if (this.MaxNumberOfFiles <= this.documents.filter(x => !x.IsDeleted).length) {
        this.isReachMaxFile = true;
        this.disabled = true;
      }
      else {
        this.isReachMaxFile = false;
        this.disabled = false;
      }
    }
  }

  convertFileToBase64(file: any): Observable<any> {
    if (file != null) {
      var reader = new FileReader();
      if (file != null) {
        return Observable.create(observer => {
          reader.readAsArrayBuffer(file);
          reader.onloadend = (e) => {
            var binary = '';
            var array = new Uint8Array(reader.result as ArrayBuffer);
            var len = array.byteLength;
            for (var i = 0; i < len; i++) {
              binary += String.fromCharCode(array[i]);
            }
            this.base64String = window.btoa(binary);
            observer.next(this.base64String);
            observer.complete();
          }
        });
      }
    }
  }

  convertBase64ToBlob(b64Data: string, contentType: string, sliceSize): Blob {
    contentType = contentType || '';
    sliceSize = sliceSize || 512;

    var byteCharacters = atob(b64Data);
    var byteArrays = [];
    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      var slice = byteCharacters.slice(offset, offset + sliceSize);

      var byteNumbers = new Array(slice.length);
      for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      var byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);
    }

    var blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  base64ToBlob(b64Data, contentType = '', sliceSize = 512) {
    b64Data = b64Data.replace(/\s/g, ''); //IE compatibility...
    let byteCharacters = atob(b64Data);
    let byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      let slice = byteCharacters.slice(offset, offset + sliceSize);

      let byteNumbers = new Array(slice.length);
      for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      let byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    return new Blob(byteArrays, { type: contentType });
  }

  _base64ToArrayBuffer(base64): any {
    var binary_string = window.atob(base64);
    var len = binary_string.length;
    var bytes = new Uint8Array(len);
    for (var i = 0; i < len; i++) {
      bytes[i] = binary_string.charCodeAt(i);
    }
    return bytes.buffer;
  }
  onRemove(event) {
    let document = this.documents.find(x => event.file.TempId == x.TempId && event.file.RealId == x.RealId);
    if (document != null) {
      let doumentIndex = this.documents.indexOf(document);
      if (doumentIndex > -1) {
        //if (document.realId != null && document.realId != "") {
        //  document.isDeleted = true;
        //}
        //else {
        //  this.documents.splice(doumentIndex, 1)
        //}
        document.IsDeleted = true;
      }
      let attachmentDoc = this.allRequestAttachments.filter(x => document.TempId == x.TempId && document.RealId == x.RealId);
      if (attachmentDoc && attachmentDoc.length > 0) {
        let allDocumentsIndex = this.allRequestAttachments.indexOf(attachmentDoc[0]);
        if (allDocumentsIndex > -1) {
          //if (document.realId != null && document.realId != "") {
          //  this.allRequestAttachments[allDocumentsIndex].isDeleted = true;
          //}
          //else {
          //  this.allRequestAttachments.splice(allDocumentsIndex, 1)
          //}
          this.allRequestAttachments[allDocumentsIndex].IsDeleted = true;
        }
      }
      this.documentsChange.emit(this.documents);
      if (this.onModelChange)
        this.onModelChange(this.documents);
      this.allRequestAttachmentsChange.emit(this.allRequestAttachments);
    }
    if (this.MaxNumberOfFiles <= this.documents.filter(x => !x.IsDeleted).length) {
      this.isReachMaxFile = true;
      this.disabled = true;
    }
    else {
      this.isReachMaxFile = false;
      this.disabled = false;
    }
    this.CheckIsRequiredValid();
  }

  IsFileAlreadyUploaded(file: any): boolean {
    let f = this.documents.find(a => a.Name == file.name);
    if (f != null && f != undefined) {
      return true;
    }
    else {
      return false;
    }
  }

  //createNewFile(file: File, count: number) {
  //  let f = new File([file], file.name + "_Copy" + count);
  //}

  //=============================================================================================
  // Oveeride File Upload methods
  OverrideValidate() {
    if (this.uploader) {
      this.uploader.validate = (file: File): boolean => {
        if (this.uploader.accept && !this.uploader.isFileTypeValid(file)) {
          if (!this.uploader.msgs) {
            this.uploader.msgs = []
          }
          this.uploader.msgs.push({
            severity: 'error',
            summary: this.uploader.invalidFileTypeMessageSummary.replace('{0}', file.name),
            detail: this.uploader.invalidFileTypeMessageDetail.replace('{0}', this.uploader.accept)
          });

          if (!this.errors) {
            this.errors = {};
          }
          this.errors.allowedExtensions = {
            errorMessage: this.resources.g_uploader_allowedFileExtensions +
              this.resources.g_lbl_space +
              this.documentConfiguration.AllowedExtension
          }
          //this.IsValid.emit(false)
          return false;
        }
        else {
          if (this.errors && this.errors.allowedExtensions) {
            delete this.errors.allowedExtensions;
          }
        }
        if (this.uploader.maxFileSize && file.size > this.uploader.maxFileSize) {
          if (!this.uploader.msgs) {
            this.uploader.msgs = []
          }
          this.uploader.msgs.push({
            severity: 'error',
            summary: this.uploader.invalidFileSizeMessageSummary.replace('{0}', file.name),
            detail: this.uploader.invalidFileSizeMessageDetail.replace('{0}', this.uploader.formatSize(this.uploader.maxFileSize))
          });
          if (!this.errors) {
            this.errors = {};
          }
          this.errors.maxFileSize = {
            errorMessage: this.resources.g_uploader_MaxFileSize +
              this.resources.g_lbl_space +
              this.documentConfiguration.AllowedSize / 1000000 +
              this.resources.g_lbl_space +
              this.resources.g_fileSizeUnitInMB
          }
          //this.IsValid.emit(false)
          return false;
        }
        else {
          if (this.errors && this.errors.maxFileSize) {
            delete this.errors.maxFileSize;
          }
        }
        if (this.errors) {
          delete this.errors;
        }
        if (this.uploader.msgs) {

          delete this.uploader.msgs;
        }
        this.IsValid.emit(true);
        return true;
      }
    }
  }
  //=============================================================================================
  CheckIsRequiredValid(): boolean {
    if (this.required && this.isUploaderReady) {
      if (this.MinNumberOfFiles == this.documents.filter(x => !x.IsDeleted).length && this.MaxNumberOfFiles <= this.documents.filter(x => !x.IsDeleted).length) {
        this.IsValid.emit(true);
        if (this.errors) {
          delete this.errors;
        }
        return true;
      }
      else {
        //if (!this.errors) {
        //  this.errors = {};
        //}
        this.errors = {};
        this.errors.required = {
          errorMessage: this.label +
            this.resources.g_lbl_space +
            this.resources.g_error_gridIsRequired
        }
        this.IsValid.emit(false)
        return false;
      }
    }
    else {
      this.IsValid.emit(true);
      if (this.errors) {
        delete this.errors;
      }
      return true;
    }
  }
  //ngDoCheck() {
  //  //const change = this.differ.diff(this);
  //  //if (change) {
  //  //  change.forEachChangedItem(item => {
  //  //    this.CheckIsRequiredValid();
  //  //  });
  //  //}
  //}

  ngOnChanges(changes: SimpleChanges): void {
    //if (change) {
    //  change.forEachChangedItem(item => {
    //    this.CheckIsRequiredValid();
    //  });
    //}
    this.CheckIsRequiredValid();
  }

  //requiredValidator(control: AbstractControl): { [key: string]: boolean } | null {
  //  if (control.value !== undefined && (isNaN(control.value) || this.CheckIsRequiredValid())) {
  //    return { 'required': true };
  //}
  //return null;
  //}
  GetErrors(errors: any): string[] {
    let result = new Array<string>();

    for (var error in errors) {
      result.push(error);
    }
    return result;
  }

  //////////////////////////////Reactive forms////////////////////////////////////


  onModelChange: Function = () => { };
  onModelTouched: Function = () => { };
  writeValue(obj: any): void {
    if (this.MaxNumberOfFiles > 1) {
      this.isMultiple = true;
    }
    if (!obj)
      this.documents = new Array<DocumentModel>();
    else
      this.documents = obj;
  }
  registerOnChange(fn: any): void {
    this.onModelChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onModelTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {

   // console.log("setDisabledState");
  }
  calculateFileToShow(size:any): string {
    if (size && size != "")
      return (size / 1024) < 1024 ? (size / 1024).toFixed() + " KB" : (size / 1048576).toFixed(2) + " MB";
    else
      return "";
  }

  uploadOfflineDocument(fileToUpload: any) {
    this.showLoader = false;
    let sizeToShow = this.calculateFileToShow(fileToUpload.size);
    let uploadedDocument: DocumentModel = {
      TempId: null,
      Name: fileToUpload.name.split('.').slice(0, -1).join('.'),
      extension: fileToUpload.name.split('.')[fileToUpload.name.split('.').length - 1],
      mimeType: fileToUpload.type,
      Size: fileToUpload.size,
      SizeToShow: sizeToShow
    };
    if (this.isMultiple) {
      this.documents.push(uploadedDocument);
      this.documentsChange.emit(this.documents);
      this.files.push(fileToUpload);
      this.filesChange.emit(fileToUpload);
    }
    else {
      if (this.documents.length == 0) {
        this.documents.push(uploadedDocument);
        this.documentsChange.emit(this.documents);
        this.files.push(fileToUpload);
        this.filesChange.emit(fileToUpload);
      }
      else {
        this.documents.pop();
        this.documents.push(uploadedDocument);
        this.documentsChange.emit(this.documents);
        this.files.pop();
        this.files.push(fileToUpload);
        this.filesChange.emit(fileToUpload);
      }
    }
  }
}
